import Login from '../components/auth/login/Login';
 
const PageLogin = () => (<Login/>);
export default PageLogin;